
































































import {PureFilterService} from '../../services/pure/filter-service'
import {PureSearchService} from '../../services/pure/search-service'
import BaseSearchLayout from '../../layout/BaseSearchLayout.vue'
import ActiveFilters from '../shared/ActiveFilters.vue'
import FilterCard from '../shared/FilterCard.vue'
import Filters from '../shared/Filters.vue'
import MessageComponent from '@/shared/components/Message.vue'
import Popup from '../shared/Popup.vue'
import PopupToggle from '../shared/PopupToggle.vue'
import SearchBar from '../shared/SearchBar.vue'
import SearchResults from '../shared/SearchResults.vue'
import {defineComponent, onMounted} from "@vue/composition-api";
import {useActions, useGetters, useMutations, useState} from "vuex-composition-helpers";

export default defineComponent({
  name: "PureSearchComponent",
  components: {
    BaseSearchLayout,
    ActiveFilters,
    FilterCard,
    Filters,
    MessageComponent,
    Popup,
    PopupToggle,
    SearchBar,
    SearchResults
  },
  setup: () => {
    const {labels, language} = useGetters(['labels', 'language'])
    const {searchResultsCount, config} = useState(['searchResultsCount', 'config']);
    const {setSearchService} = useMutations(['setSearchService'])
    const {loadData} = useActions(['loadData'])
    const {removeFilter} = useActions('filter', ['removeFilter'])
    const {
      resetActiveFilters,
      setFilterService,
      toggleMobileFilters
    } = useMutations('filter', ['resetActiveFilters', 'setFilterService', 'toggleMobileFilters'])
    const {activeFilterItems, mobileFilters} = useState('filter', ['activeFilterItems', 'mobileFilters']);
    const {activeFilters, filterGroupDisplayNames,} = useGetters('filter', ['activeFilters', 'filterGroupDisplayNames'])

    onMounted(() => {
      try {
        setSearchService(new PureSearchService(language.value, config.value))
        setFilterService(new PureFilterService([], labels.value))
      } catch (error) {
        console.error(error)
      } finally {
        loadData([false])
      }
    })

    return {
      searchResultsCount,
      toggleMobileFilters,
      filterGroupDisplayNames,
      activeFilters,
      resetActiveFilters,
      removeFilter,
      activeFilterItems,
      labels,
      mobileFilters
    }
  }
})
